import { render, staticRenderFns } from "./DoctorTeachMainPage.vue?vue&type=template&id=7462461a&scoped=true&"
import script from "./DoctorTeachMainPage.vue?vue&type=script&lang=js&"
export * from "./DoctorTeachMainPage.vue?vue&type=script&lang=js&"
import style1 from "./DoctorTeachMainPage.vue?vue&type=style&index=1&id=7462461a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7462461a",
  null
  
)

export default component.exports